import hgpScanPicture from './main';

export default {
  install(Vue) {
    Vue.component(hgpScanPicture.name, hgpScanPicture);
  },
};

